import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ssoClientsKeys } from "Api/Queries/SsoClients/useSsoClientsQuery";
import { deleteSsoClientsClientId } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useDeleteSsoClientMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((clientId: string) =>
      deleteSsoClientsClientId(clientId),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ssoClientsKeys.all });
      onSuccess?.();
    },
    onError,
  });
};
